import * as R from "ramda";

import {
  deepFindByUID,
} from "./doc_helpers";

export function applyState<T extends PossibleContent>(rootNode: T, state: State): T {
  const mapValue = (stateSet: Record<string, InnerState>) => R.map((valueData: InnerState) => valueData.value, stateSet);
  const strippedState = R.map(mapValue, state);

  R.toPairs(strippedState).forEach(([uid, kvs]) => {
    const node = deepFindByUID(rootNode, uid);
    if (node) {
      R.toPairs(kvs).forEach(([key, value]) => {
        (node as any)[key] = value;
      });
    }
  });

  return rootNode;
}
